import _ from 'lodash';
import { FormControl } from '@angular/forms';
import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { QuotationService, PickUpModel, AlertService, GmapLogService } from '../../../../services/index';
import { Util } from '../../../../utils'
declare var $:any;
declare var google:any;
declare var moment:any;

@Component({
  selector: 'container-info-message',
  templateUrl: 'info-message.html'
})

export class InfoMessageComponent {
  @Input() cnsltnReq;
  @Input() cnsltnQuotLst;
  @Input() smallestCost;
  @Input() crncy;
  @Input() statusCd;
  @Input() cnsltnMessage;
  @Input() cnsltnBook;
  
  pickUpDate: FormControl = new FormControl({ value:'', disabled: true });
  pickUpTime: FormControl = new FormControl({ value:'', disabled: true });
  pickUpLocation: FormControl = new FormControl({ value:'', disabled: true });

  pickUpEditing: boolean = false;

  dateSet: Date;
  bookedQuot;

  dateFomatter: Function = Util.dateFomatter;
  timeFomatter: Function = Util.timeFomatter;
  currencyFormat: Function = Util.currencyFormat;

  pickUp: PickUpModel = new PickUpModel();

  leftDays;
  
  isPickUp: boolean = false;

  @ViewChild("pickUpDate")
  dateElementRef: ElementRef;

  @ViewChild("pickUpAddress")
  addressElementRef: ElementRef;
  
  constructor(
    private mapsAPILoader: MapsAPILoader,
    private quotationService: QuotationService,
    private alertService: AlertService,
    private gmapLogService: GmapLogService
  ) {}

  ngOnInit() {
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.addressElementRef.nativeElement, {field: ["name", "formatted_address"]});
      this.gmapLogService.log('consult-detail', 'PLACE');
    });
  }
  
  ngOnChanges() {
    this.getConsultInfo(this.cnsltnReq);

    if(this.cnsltnBook != undefined && this.cnsltnBook.docCloseDt != null) {
      if(this.cnsltnBook.docCloseTm == null) {
        let docClose = this.cnsltnBook.docCloseDt + '00:00';
        this.leftDays = this.getLeftDaysAndHours(docClose);
      } else {
        let docClose = this.cnsltnBook.docCloseDt + this.cnsltnBook.docCloseTm;
        this.leftDays = this.getLeftDaysAndHours(docClose);
      }
      
    }

  }

  getConsultInfo(req) {
    let pickupDt = this.cnsltnReq.pickupDt;
    let pickupTm = this.cnsltnReq.pickupTm;
    let pickupAdrs = this.cnsltnReq.pickupAdrs;
    if(pickupDt != null) {
      this.pickUpDate.setValue(moment(pickupDt).format('MM/DD/YYYY'));
      this.dateChange(pickupDt);
    } else {
      if(this.cnsltnReq.transExptDt != null) {
        let dt = moment(this.cnsltnReq.transExptDt, 'YYYYMMDD').format('MM/DD/YYYY');
        this.pickUpDate.setValue(dt);
        this.dateChange(this.cnsltnReq.transExptDt);
      }
    }
    if(pickupTm!=null) {
      this.pickUp.pickupTm = pickupTm;
      this.pickUpTime.setValue(moment(pickupTm, 'hmm').format('h:mm A'));
    }
    if(pickupAdrs!=null) {
      this.pickUpLocation.setValue(pickupAdrs);
    } else {
      if(this.cnsltnReq.imexTp == 0) {
        let adrs = '';
        if(this.cnsltnReq.orgAdrsDtl != null) {
          adrs = this.cnsltnReq.orgAdrs + this.cnsltnReq.orgAdrsDtl;
        } else {
          adrs = this.cnsltnReq.orgAdrs;
        }
        this.pickUpLocation.setValue(adrs);
        this.pickUp.pickupAdrs = adrs;
      } else {
        let adrs = '';
        if(this.cnsltnReq.desAdrsDtl != null) {
          adrs = this.cnsltnReq.desAdrs + this.cnsltnReq.desAdrsDtl;
        } else {
          adrs = this.cnsltnReq.desAdrs;
        }
        this.pickUpLocation.setValue(adrs);
        this.pickUp.pickupAdrs = adrs;
      }
    }

    if(this.cnsltnReq.quotNo != null) {
      this.bookedQuot = _.find(this.cnsltnQuotLst, {quotNo : this.cnsltnReq.quotNo});
    }

    if((this.cnsltnReq.imexTp == 0 && this.cnsltnReq.orgTp == 1) || (this.cnsltnReq.imexTp == 1 && this.cnsltnReq.desTp == 1)) {
      this.isPickUp = true;
    }
  }

  editPickUp() {
    this.pickUpEditing = true;
    this.pickUpDate.enable();
    this.pickUpTime.enable();
    this.pickUpLocation.enable();
  }

  dateChange(event) {
    this.pickUp.pickupDt = moment(event).format('YYYYMMDD');
  }
  
  timeChange(event) {
    this.pickUp.pickupTm = moment(event).format('HHmm');
  }

  submitPickUp() {
    this.pickUp.pickupAdrs = this.addressElementRef.nativeElement.value;    
    if(_.isEmpty(this.pickUp.pickupDt)) {
      this.alertService.error('픽업일을 입력해주세요.');
      return;
    } else if(_.isEmpty(this.pickUp.pickupAdrs)) {
      this.alertService.error('픽업지를 입력해주세요.')
      return;
    } else {
      this.pickUpEditing = false;
      this.pickUpDate.disable();
      this.pickUpTime.disable();
      this.pickUpLocation.disable();
      this.modal();
      return;
    }
  }

  postPickUpInfo() {
    this.quotationService.postPickUp(this.cnsltnReq.reqNo, this.pickUp).subscribe();
    this.modal();
    return;
  }

  modal() {
		if($('.last-check-modal .sweet-modal-overlay').hasClass('open')) {
			$('.last-check-modal .sweet-modal-overlay').removeClass('open');
		} else {
			$('.last-check-modal .sweet-modal-overlay').addClass('open');
		}		
  }

  getLeftDaysAndHours(docClose) {    
    var eventTime = moment(docClose, 'YYYYMMDD HH:mm').unix(),
    currentTime = moment().unix(),
    diffTime = eventTime - currentTime,
    duration = moment.duration(diffTime * 1000, 'milliseconds'),
    interval = 1000;

    if(diffTime > 0) {
      duration = moment.duration(duration.asMilliseconds() - interval, 'milliseconds');
        var d = moment.duration(duration).days(),
            h = moment.duration(duration).hours(),
            m = moment.duration(duration).minutes(),
            s = moment.duration(duration).seconds();
      
      return d + '일' + h + '시간' + m + '분';
    } else {
      return '서류 마감';
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/detail/info-message.ts